// private config

const development = {
    purecloud: {
        clientId: 'ccdbf5f5-4467-4bf9-894a-5db5b826a06d',
    },
    pureconnect: {
        primary: '',
        backup: '',
        //Leave identityProviderName blank if not using SSO and using IC auth
        //If using windows authentication, make this "Windows Authentication" exactly.
        identityProviderName: 'Windows Authentication',
        baseUrl: 'http://<hostname>:8018/icws',
        applicationName: 'G2Connect'
    },
    pureengage: {

    },
    product: 'purecloud',
    endpoints: {}
}

const production = {
    purecloud: {
        clientId: '',
    },
    pureconnect: {
        primary: '',
        backup: '',
        //Leave identityProviderName blank if not using SSO and using IC auth
        //If using windows authentication, make this "Windows Authentication" exactly.
        identityProviderName: 'Windows Authentication',
        baseUrl: 'http://<hostname>:8018/icws',
        applicationName: 'G2Connect'
    },
    pureengage: {

    },
    product: 'purecloud',
    endpoints: {}
}

const test = {
    purecloud: {
        clientId: '',
    },
    pureconnect: {
        primary: '',
        backup: '',
        //Leave identityProviderName blank if not using SSO and using IC auth
        //If using windows authentication, make this "Windows Authentication" exactly.
        identityProviderName: 'Windows Authentication',
        baseUrl: 'http://<hostname>:8018/icws',
        applicationName: 'G2Connect'
    },
    pureengage: {

    },
    product: 'purecloud',
    endpoints: {}
}

const env = process.env.REACT_APP_CUSTOM_ENV.trim()
console.log('env:', env)
let config
switch (env) {
    case 'production': config = production; break;
    case 'development': config = development; break;
    case 'test': config = test; break;
    default: break;
}

export default config
export const headerTitle = "G2Connect"